/**
 * @file   src\Pages\Locations.tsx
 * @brief  Locations page.
 * @date   JUN, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import { React, useNavigate, Button, useParams, useEffect, useState, useRef, useLocation } from "../utils/thirdpartyComponents";
import { pageURLs } from 'src/utils/pageUrls';
import Advertisement from "./Advertisement";
import "src/styles/inner-page-styles.scss";
import { bayTypeLabelMap, EquipmentTypeId } from "src/utils/enums";

const ScannerSuccess = () => {
  const navigate = useNavigate();
  // Route information variable
  const params = useParams();
  const location = useLocation();
  const washName = location?.state?.washName;
  const bayName = location?.state?.bayName;
  const bayNumber=location?.state?.bayNumber;
  const bayTypeID=location?.state?.bayTypeID

  const queryParams = new URLSearchParams(location.search);
  const washType = (queryParams.get('washType') === "1" || queryParams.get('washType') === "2") ?  queryParams.get('washType')  : 0;
  
  useEffect(() => {
    if (!(location.state?.bayStatusSuccess)) {
      navigate("/" + params.carwashname + "/" + pageURLs.home);
    }
  }, []);
  const audioRef = useRef<HTMLAudioElement>(null);
  const [isPlaying, setIsPlaying] = useState(false);

    function getBayLabel(bayName:string,bayNumber:number,bayTypeID:number): any {
    if (bayName) return bayName;
    if (bayTypeID && bayNumber) {
      return `${bayTypeLabelMap[bayTypeID] || "Unknown"} ${bayNumber}`;
    }
    return "Unknown";
  }

  const handlePlayAudio = () => {
    if (audioRef.current && !isPlaying) {
      audioRef.current.play().then(() => {
        setIsPlaying(true);
      }).catch((error: any) => {
        console.error("Audio play failed:", error);
      });
    }
  };
  useEffect(() => {
    handlePlayAudio();
  }, []);
  
  const OkbuttonClick = () => {
    navigate("/"+params.carwashname+"/"+pageURLs.home);
  };
  return (

    <div className="common-content-wrap pb-115" onMouseEnter={handlePlayAudio} onMouseLeave={handlePlayAudio}>
      <div className="inner-content-wrap signup-block">
        <div className="common-header">
          <div className="pe-4 ps-4 pt-0 pb-0 h-100">
            <div className="common-header-inner">Bay Status</div>
          </div>
        </div>
        <div className="main-content-wrap pe-0 ps-0 pt-0">
       
          <div className="scanner-status-wrap position-relative">
            <div className="bay-title d-flex flex-column" >
              <p className="fw-bold m-0">Bay name: {getBayLabel(bayName,bayNumber,bayTypeID)}</p>
            <p className="fw-bold m-0">{bayTypeID==EquipmentTypeId.Vacuum? "Vacuum name":"Wash name" }: {washName}</p>
            </div>

          {/* <h5 className="mb-4 text-capitalize" > {washName}</h5> */}
            

            <div className="status-img-wrap">
              <svg xmlns="http://www.w3.org/2000/svg" width="122.137" height="165.216" viewBox="0 0 122.137 165.216"><g transform="translate(-129.863 -177.706)"><g transform="translate(129.863 226.95)"><path d="M57.986,5A53,53,0,0,0,37.363,106.81,53,53,0,0,0,78.609,9.162,52.65,52.65,0,0,0,57.986,5m0-5A57.986,57.986,0,1,1,0,57.986,57.986,57.986,0,0,1,57.986,0Z" transform="translate(0 0)" fill="#53ce1f" /><circle cx="5.341" cy="5.341" r="5.341" transform="translate(28.163 38.846)" fill="#53ce1f" /><circle cx="5.341" cy="5.341" r="5.341" transform="translate(76.236 38.846)" fill="#53ce1f" /><path d="M-173.633,1597.529c6.756,3.5,24.612,3.852,36.03-.9s-1.967,19.7-19.7,18.57-21.131-15.823-21.131-15.823S-180.389,1594.031-173.633,1597.529Z" transform="translate(214.729 -1526.19)" fill="#53ce1f" /></g><g transform="translate(184.167 221.405) rotate(-90)"><path d="M10.613,5.138a10.885,10.885,0,0,0,5.475,5.475,10.885,10.885,0,0,0-5.475,5.475,10.885,10.885,0,0,0-5.475-5.475,10.885,10.885,0,0,0,5.475-5.475m0-5.138A10.24,10.24,0,0,1,0,10.613,10.24,10.24,0,0,1,10.613,21.227,10.24,10.24,0,0,1,21.227,10.613,10.24,10.24,0,0,1,10.613,0Z" transform="translate(0 40.441)" fill="#5eda29" /><path d="M5.557,0A5.361,5.361,0,0,1,0,5.557a5.361,5.361,0,0,1,5.557,5.557,5.361,5.361,0,0,1,5.557-5.557A5.361,5.361,0,0,1,5.557,0Z" transform="translate(18.506)" fill="#5eda29" /></g><path d="M3,1A2,2,0,1,0,5,3,2,2,0,0,0,3,1M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z" transform="translate(203 187)" fill="#5eda29" /><path d="M5,1A4,4,0,1,0,9,5,4,4,0,0,0,5,1M5,0A5,5,0,1,1,0,5,5,5,0,0,1,5,0Z" transform="translate(218 189)" fill="#5eda29" /><path d="M2.5,1A1.5,1.5,0,1,0,4,2.5,1.5,1.5,0,0,0,2.5,1m0-1A2.5,2.5,0,1,1,0,2.5,2.5,2.5,0,0,1,2.5,0Z" transform="translate(201 201)" fill="#5eda29" /><path d="M6,2a4,4,0,1,0,4,4A4,4,0,0,0,6,2M6,0A6,6,0,1,1,0,6,6,6,0,0,1,6,0Z" transform="translate(240 227)" fill="#5eda29" /><g transform="translate(203.934 158.823) rotate(45)"><path d="M7.6-.5a.889.889,0,0,1,.888.888c0,2.81.343,4.3,1.186,5.142s2.332,1.186,5.142,1.186a.888.888,0,0,1,0,1.776h0c-2.81,0-4.3.344-5.142,1.186S8.491,12.009,8.491,14.82a.888.888,0,0,1-1.776,0c0-2.81-.343-4.3-1.186-5.142S3.2,8.491.388,8.491a.888.888,0,1,1,0-1.776c2.81,0,4.3-.343,5.142-1.186S6.715,3.2,6.715.388A.889.889,0,0,1,7.6-.5ZM12.4,7.6A5.532,5.532,0,0,1,8.97,6.237,5.532,5.532,0,0,1,7.6,2.81,5.532,5.532,0,0,1,6.237,6.237,5.532,5.532,0,0,1,2.81,7.6,5.532,5.532,0,0,1,6.237,8.97,5.533,5.533,0,0,1,7.6,12.4,5.533,5.533,0,0,1,8.97,8.97,5.532,5.532,0,0,1,12.4,7.6Z" transform="translate(0 54.865)" fill="#5eda29" /><path d="M4.17,8.339a.388.388,0,0,1-.388-.388c0-2.823-.571-3.394-3.394-3.394a.388.388,0,1,1,0-.776c2.823,0,3.394-.571,3.394-3.394a.388.388,0,0,1,.776,0c0,2.823.571,3.394,3.394,3.394a.388.388,0,0,1,0,.776c-2.823,0-3.394.571-3.394,3.394a.388.388,0,0,1-.388.388Zm-1.2-4.17a2.256,2.256,0,0,1,1.2,1.2,2.256,2.256,0,0,1,1.2-1.2,2.256,2.256,0,0,1-1.2-1.2A2.256,2.256,0,0,1,2.967,4.17Z" transform="translate(26.704 0)" fill="#5eda29" /></g></g></svg>
            </div>
            <h2>Yay!</h2>
            <p>The selected bay is available.<br /> Please proceed.</p>
            {(washType == 2) ? <h6>One wash will be reduced from your subscription.</h6> : ''}
          </div>
        </div>
      </div>
      <div className="btm-wrap">
        <div className="btm-inner-wrap">
          <Button variant="primary" className="primary-btn btn-main" onClick={OkbuttonClick}>OK</Button>
        </div>
      </div>

      {/* comment for now only (dummy data)  */}
      <Advertisement />
      
      {(washType != 2) ? <audio
        ref={audioRef}
        src="https://carwash-storage.s3.us-east-2.amazonaws.com/staticfiles/voice-single-wash.mp3"
        controls
        hidden
      /> : 
      <audio
      ref={audioRef}
      src="https://carwash-storage.s3.us-east-2.amazonaws.com/staticfiles/bay-available.mp3"
      controls
      hidden
    /> }
    </div>
  )
}

export default ScannerSuccess;
